require('../../modules/es6.object.is');
module.exports = require('../../modules/_core').Object.is;



//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/~/core-js/library/fn/object/is.js
// module id = 470
// module chunks = 0